<template>
  <div id="app">
    <!-- <keep-alive exclude="AddPosts,AddVideo,AddActivity"> -->
    <router-view />
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {},
  created() {
    let keyExpire = localStorage.getItem('key-expire');
    // 当前时间 已经超过 设置的过期时间
    if (keyExpire < new Date().valueOf()) {
      localStorage.clear()
    }
  },
};
</script>

<style>
@import "./assets/css/common.css";
#app {
  box-sizing: border-box;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue